import React, { useEffect, useState } from 'react';
import Button from '../Button';
import useStyles from './style';

/**
 *
 * mode: It has 3 modes. 1) default -> Reloads the application, 2) custom -> needs to pass the custom function to trigger on click, 3) none -> It will not trigger any function as the button is view only
 * reload: Provide custom function from parent component if the mode is set as custom, by default is empty function.
 *
 */
const Errorpage = ({ mode, onReload = () => {} }) => {
  const classes = useStyles();
  const onClickFn = () => {
    if (mode === 'default') {
      window.location.reload();
    } else if (mode === 'custom') {
      onReload();
    }
  };
  return (
    <div className={classes.parentContainer}>
      <div className={classes.childContainer}>Opps, something went wrong.</div>
      <div className={classes.button}>
        <Button scheme="dark" onClick={onClickFn}>
          Reload
        </Button>
      </div>
    </div>
  );
};

export default Errorpage;
